import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/pranesh.g/Documents/opensource/use-key-capture-2/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <h3 {...{
      "id": "keydata"
    }}>{`keyData`}</h3>
    <p>{`It will be the most used props from `}<inlineCode parentName="p">{`useKeyCapture`}</inlineCode>{`. It gives the key/key varient/key combinations pressed.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isEnter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isBackspace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isEscape`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isCapsLock`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isTab`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isSpace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isArrow`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isArrowRight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isArrowLeft`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isArrowUp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isArrowDown`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isWithShift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isWithCtrl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isWithMeta`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isWithAlt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isCaps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isSmall`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isNumber`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isSpecialCharacter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "gettargetprops"
    }}>{`getTargetProps`}</h3>
    <p><inlineCode parentName="p">{`type: function({})`}</inlineCode></p>
    <p>{`A prop getter to be given if a target (input, textarea) have to be listened for key-press.`}</p>
    <h3 {...{
      "id": "resetkeydata"
    }}>{`resetKeyData`}</h3>
    <p><inlineCode parentName="p">{`type: function({})`}</inlineCode></p>
    <p>{`It will reset all the values in `}<inlineCode parentName="p">{`keyData`}</inlineCode>{` props to the initial values.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      